import { CustomValidation } from './CustomValidation';
import { Attribute } from './Attribute';
import { ControlLayout } from '../Enums/ControlLayout';
import { FileType } from '../Enums/FileType';
import { FileDTO } from './FileDTO';
import { ImageType } from '../Enums/ImageType';

export class ImageUploadOptions {
    /**
 * Represent Name Of Form Control
 */
Name:string
/**
*   Represent classes to ImageUpload that allow us to select the FileInput by jquery or javascript 
*/

ExtraClasses:string

/**  Represent value of the label*/
LabelValue:string
 /**  Represent Key of the label*/
 LabelKey:string
/**  Represent value of the labelDescription show under ImageUpload*/
LabelDescription:string
/**To set  value  to ImageUpload */
Value:FileDTO
/**
  * Display "*" beside the label 
  * if ForceAsterisk=true and IsRequired=True his display "*" ,
  * if if ForceAsterisk=false and IsRequired=false this remove "*",
  *if ForceAsterisk=false and IsRequired=True this display "*" , 
   */ 
  ShowAsterisk: boolean
  /** Ability to set  ImageUpload required */
  IsRequired: boolean
  /** Ability to display or hide the label of ImageUpload */
  HideLabel:  boolean
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean
   /** Allow to Upload Multiple File  */
   IsMultiple: boolean= false
    /** Allow to Use Drop Zone  */
   AllowDropZone: boolean= false
   /** Sets an attribute AllowImageCropper="true"  */
    AllowImageCropper: boolean
   /** Set Height  of Image Cropper Box */
   ImageCropperHeight: number
    /** Set Width of Image Cropper Box  */
   ImageCropperWidth: number
  /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
  */
 CustomValidation: CustomValidation[]=[]
 /** Set List of Custom Attribute to FileInput  */
  AttributeList:Attribute[]
  /** Set File MaxSize In MB  */
  FileMaxSizeInMB: number;
  /**  to set type of view  if FileInput is Vertical or Horizontal */
  ViewType:ControlLayout=ControlLayout.Vertical
   /** Set List of Custom Attribute to FileInput  */
   FileUploadAcceptsTypes:ImageType[]=[ImageType.ImageTypes]
   /** Set Default Image  */
   DefaultImageSrc:string
  }
  